import { useContext } from 'react';
import * as R from 'ramda';

import workTypeLocationIcon from '@atom/components/common/svgIcons/workTypeLocationIcon.svg';
import SchemaDetailContext from '@atom/components/schemaDetail/SchemaDetailContext';

import PreviewAttributeDetails from './PreviewAttributeDetails';

import classes from './previewInfo.module.css';

const PreviewInfo = () => {
  const { schemaTree } = useContext(SchemaDetailContext);

  const showLocationPane = !R.isNil(schemaTree.locationType);

  return showLocationPane ? (
    <>
      <div className={classes.leftBodyPaneHalf}>
        <PreviewAttributeDetails schema={schemaTree} />
      </div>
      <div className={classes.rightBodyPaneHalf}>
        <div className={classes.locationSection}>
          <div className={classes.locationContent}>
            <img className={classes.locationImage} src={workTypeLocationIcon} />
            <div className={classes.locationTitle}>
              Location is determined during asset creation.
            </div>
            <div className={classes.locationText}>
              When an asset is created, this section will display the location
              of that asset on a map.
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <div className={classes.centerPaneContainer}>
      <div className={classes.centerPane}>
        <PreviewAttributeDetails schema={schemaTree} />
      </div>
    </div>
  );
};

export default PreviewInfo;
